import { createContext } from 'react';

export const DrawerContext = createContext<{
  showDrawer: boolean;
  setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  showDrawer: false,
  setShowDrawer: () => {
    console.warn('setShowDrawer is called without a provider');
  },
});
